import React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import Grid from "@mui/material/Grid";
import CatalogInfoButton from "../catalog-info-button";
import CatalogMetadataButton from "../catalog-metadata-button";
import CustomLink from "../custom-link";

const CardsGrid = ({id = null, list, getHref, onClick, imageStyle, hideLabelOnElemWithImage, icon, size = 12}) => (
  <Grid id={id} container spacing={2} className="cards-grid">
    {list.map((c, i) => (
      <Grid id={`cards-grid__category__${c.id}`} className="cards-grid__category" key={i} size={size}>
        <Card
          id={`cards-grid__card-${c.id}`}
          className="cards-grid__category__card"
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between"
          }}
        >
          <CustomLink
            to={getHref(c)}
            sx={{
              "& .custom-link__content__image > img": {
                height: "210px",
                width: "100%",
                objectFit: "cover",
                display: "block"
              },
              "& .custom-link__content__icon-and-text__icon": {
                display: c?.image ? "none" : "flex"
              }
            }}
            text={hideLabelOnElemWithImage && c?.image ? null : c?.label}
            textStyle={
              hideLabelOnElemWithImage && c?.image
                ? {
                    padding: 0
                  }
                : {
                    padding: 16,
                    fontSize: 20
                  }
            }
            icon={hideLabelOnElemWithImage && c?.image ? null : icon}
            image={c?.image}
            onClick={onClick}
          />
          {(c.description || c.metadataUrl) && (
            <CardActions className="cards-grid__category__card__actions">
              {c.description && <CatalogInfoButton title={c?.label} description={c.description} />}
              {c.metadataUrl && <CatalogMetadataButton metadataUrl={c.metadataUrl} iconSize="small" />}
            </CardActions>
          )}
        </Card>
      </Grid>
    ))}
  </Grid>
);

export default CardsGrid;
